import { useTranslation } from "react-i18next";
import { GetVehicleCondition } from "../../Components/Tables/Vehicles/GetVehicleCondition";

const SelectedCell = ({ mechanic, status, tasks, close }) => {
  const { t } = useTranslation();
  return (
    <div className="page-mask page-mask-animation">
      <div className="edit-modal white-cont">
        <h2 className="global-h2">{mechanic}</h2>
        <GetVehicleCondition condition={status} />
        {tasks.map((task, idx) => (
          <div className="full-cont">
            <p className="max-width-700" key={idx}>
              <strong>{t("yard-tables.table-columns.description")}: </strong>{" "}
              {task.description}
            </p>
            <p>
              <strong>{t("general.unit")}:</strong>{" "}
              {task.maintenance_report.unit}
            </p>

            <hr />
          </div>
        ))}
        <div className="full-cont">
          <button className="cancel-btn all-btn" type="button" onClick={close}>
            {t("buttons.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectedCell;
